import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';

export interface CustomMetric {
  name: string;
  id: number;
  code: string;
}

export interface CustomMetrics {
  metrics: Array<CustomMetric>;
}

export function useCustomGoalsApi() {
  const { post, get, loading } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: true,
    },
  }));

  const getCustomGoals = async () => {
    const goals: CustomMetrics = await get(routes.customMetrics);
    return goals;
  };

  const setCustomGoals = async (goal: CustomMetric) => {
    const goals: CustomMetrics = await post(routes.customMetrics, goal);
    return goals;
  };

  const delCustomMetric = async (goal: CustomMetric) => {
    const goals: CustomMetrics = await post(routes.delCustomMetric, goal);
    return goals;
  };

  return { getCustomGoals, loading, setCustomGoals, delCustomMetric };
}
